import zhCN from '../assets/i18n/zh-CN';
import enUS from '../assets/i18n/en-US';

export const LANGUAGES = [
  // {
  //   code: 'zh-cn',
  //   lang: '简体中文',
  //   prefix: 'CN',
  // },
  {
    code: 'en-us',
    lang: 'English',
    prefix: 'US',
  },
];

export const I18N_LANGUAGES = ['en-us'];
export const DEFAULT_LANG = 'en-us';

export const I18N = {
  'en-us': enUS,
  // 'zh-cn': zhCN,
};
